import { ENGINE_TYPES, ENGINE_PLAYOUT_SWITCHER_PATH, NODE_CHANNEL_STATE } from "./constants";
import store from "../../store";
import { selectors as NODE_PLAYOUT_PLAYLIST_SELECTORS } from "../../ducks/nodePlayoutPlaylist";

/**
 * Stable string for table sort matching Input source cell:
 * Playout — playlist path-0 (N/A / EMERGENCY / parsed label); empty inputs — N/A; else — playingSource.
 */
export const getInputSourceDisplaySortKey = (record) => {
  const status = record?.status;
  const config = record?.config;
  const type = config?.type;
  const channelId = status?.channelId;
  const inputsStatus = status?.inputs;
  const playingSource = status?.playingSource ?? "";
  const requestedStatusText = status?.requestedStatusText;

  if (type === ENGINE_TYPES.PLAYOUT) {
    const state = store.getState();
    const elemPath0 = NODE_PLAYOUT_PLAYLIST_SELECTORS.getPlayoutPlaylistElemPath0(state, +channelId);
    const isStarted = requestedStatusText === NODE_CHANNEL_STATE.STARTED;
    const isNotAvailable = elemPath0 === "N/A";

    if (!isStarted || isNotAvailable) {
      return "N/A";
    }

    if (elemPath0 === ENGINE_PLAYOUT_SWITCHER_PATH.EMERGENCY) {
      return "EMERGENCY";
    }

    const parsed = (elemPath0 || "").split("(")[0].trim();

    return parsed || "N/A";
  }

  if (inputsStatus && inputsStatus.length === 0) {
    return "N/A";
  }

  return String(playingSource);
};

export const compareInputSourceColumn = (a, b) => {
  const ka = getInputSourceDisplaySortKey(a);
  const kb = getInputSourceDisplaySortKey(b);
  const byKey = ka.localeCompare(kb, undefined, { sensitivity: "base", numeric: true });

  if (byKey !== 0) {
    return byKey;
  }

  const na = a?.config?.name ?? "";
  const nb = b?.config?.name ?? "";

  return na.localeCompare(nb, undefined, { sensitivity: "base", numeric: true });
};
